import { gql } from '@urql/core';
import {
    CollegeMyProfileDocument,
    CollegeMyProfileQuery,
    CollegeMyProfileQueryVariables,
} from 'generated/spin-graphql';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { useAuthenticatedQuery } from '../../../client/hooks';
import { CollegeProfile } from '../../colleges/profile-page/CollegeProfile';
import { GenericInLayoutPageLoading } from '../../common/GenericFullPageLoading';

gql`
    query CollegeMyProfile($id: uuid!) {
        espin_college_by_pk(id: $id) {
            ...CollegeProfile
        }
    }
`;

export function CollegeMyProfile({ user }: { user: AppStateUser }) {
    const { isReady, data } = useAuthenticatedQuery<CollegeMyProfileQuery, CollegeMyProfileQueryVariables>(
        {
            query: CollegeMyProfileDocument,
            variables: useMemo(() => ({ id: user?.college_profile?.college?.id }), [user]),
            pause: !!!user?.college_profile?.college?.id,
        },
        ['espin_college'],
    );

    if (!isReady) {
        return <GenericInLayoutPageLoading />;
    }
    return (
        <div className="college-my-profile-container">
            <div className="profile-container">
                <CollegeProfile college={data.espin_college_by_pk} />
            </div>
            <Link href="/dashboard/my-profile/edit">
                <a className="button large-button blue-button">Edit Profile</a>
            </Link>
        </div>
    );
}
